import React from 'react';

import classNames from 'classnames';

export interface TitleProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> {
  title: string;
  /** sm - text-sm: 14px | sm - text-base: 16px */
  size?: 'sm' | 'md';
}

export const Title = ({ title, size = 'sm', className, ...props }: TitleProps) => (
  <h3
    className={classNames(
      'font-semibold',
      {
        'text-base': size === 'md',
        'text-sm': size === 'sm',
      },
      className
    )}
    {...props}
  >
    {title}
  </h3>
);
